import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import React, { Component, Fragment } from 'react';
import ImmocomContext from '../../contexts/ImmocomContext';
import { DataTache } from '../../data/DataTache';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxEtat } from '../ComboBox/ComboBoxEtat';
import { ComboBoxTypeDeDemande } from '../ComboBox/ComboBoxTypeDeDemande';
import { EUIDetailsList } from '../EUI/EUIDetailsList';
import { EUIPanel } from '../EUI/EUIPanel';
import { FicheTache } from '../Fiche/FicheTache';

// KP - 26/06/2023 : composant raccordé à ImmocomContext pour tests
export class DetailsListTache extends Component {

    static contextType = ImmocomContext;

    static defaultProps = {
        masquerOngletTickets: false,
        onSelectionTache: idTache => null,
    };

    static defaultState = {
        itemActif: {},
        items: [],
        afficherPanelTache: false,
        afficherPanelFiltres: false,
        /* ----- */
        facteurNbreEnregistrement: 50,
        pageIndex: 1,
    };

    constructor(props) {
        super(props);
        this.state = { ...DetailsListTache.defaultState };
        this._columns = this._getColumns();
        this._filtres = this._getFiltres();
        this._isSortedDescending = true;
        this._sortedColumn = "idTache";
    };

    _appliquerFiltres = (filtres) => {
        this._filtres = { ...this._filtres, ...filtres };
        this.setState({ pageIndex: 1 });
        this._togglePanel("Filtres", false, null, this._chargementDonnees)();
    };

    _chargementDonnees = () => {

        const { addMessage, dismissMessage, fetchMessages } = this.context;
        const messageId = addMessage("loading", "Chargement des projets en cours...");

        const { facteurNbreEnregistrement, pageIndex } = this.state;
        const tri = `${this._sortedColumn} ${this._isSortedDescending ? "DESC" : "ASC"}`;

        DataTache._listerDetailsList(this._filtres, tri, facteurNbreEnregistrement, pageIndex).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                let items = [];
                let newItems = responseFetch.reponseAPIobjet || [];

                if (this.state.pageIndex === 1) {
                    items = newItems;
                }
                else {
                    items = [...this.state.items];
                    items = items.concat(newItems);
                }

                const state = { items };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
            }
            else {
                fetchMessages(responseFetch);
                this.setState({ items: [] });
            }
            dismissMessage(messageId);
        });

    };

    _getColumns = () => {

        let columns = [{
            key: "idTache",
        }, {
            key: "titre",
            name: "Titre",
        }, {
            className: "ms-hiddenMdDown",
            headerClassName: "ms-hiddenMdDown",
            key: "dateDemande",
            name: "Date de demande",
        }, {
            className: "ms-hiddenSm",
            headerClassName: "ms-hiddenSm",
            key: "priorite",
            minWidth: 60,
            maxWidth: 60,
            name: "Priorité",
            onRender: item => {
                const priorite = item.priorite;
                let classBadge = null;
                switch (priorite) {
                    case "Basse": classBadge = "success"; break;
                    case "Médium": classBadge = "warning"; break;
                    case "Haute": classBadge = "danger"; break;
                    default: classBadge = "secondary"; break;
                }
                return <span title={priorite} className={"badgePriorite badge badge-" + classBadge}>{priorite}</span>;
            }
        }, {
            className: "ms-hiddenLgDown",
            headerClassName: "ms-hiddenLgDown",
            key: "typeDeDemande",
            minWidth: 80,
            maxWidth: 200,
            name: "Type de demande",
        }, {
            minWidth: 50,
            maxWidth: 200,
            key: "etat",
            name: "Etat",
        }, {
            className: "ms-hiddenXlDown",
            headerClassName: "ms-hiddenXlDown",
            key: "assigneA",
            minWidth: 80,
            maxWidth: 100,
            name: "Assignée à",
        }, {
            className: "ms-hiddenLgDown",
            headerClassName: "ms-hiddenLgDown",
            key: "domaine",
            minWidth: 100,
            maxWidth: 200,
            name: "Domaine",
        }, {
            className: "ms-hiddenLgDown",
            headerClassName: "ms-hiddenLgDown",
            key: "fonctionnalite",
            minWidth: 100,
            maxWidth: 200,
            name: "Fonctionnalité",
        }, {
            className: "ms-hiddenXlDown",
            headerClassName: "ms-hiddenXlDown",
            isIconOnly: true,
            key: "nbreTicketsOuvert",
            onRender: item => {
                const nbreTicketsOuvert = item.nbreTicketsOuvert;
                return !!nbreTicketsOuvert && <span title="Tickets ouverts" className="badge badge-danger" >{nbreTicketsOuvert}</span>;
            }
        }, {
            className: "ms-hiddenXlDown",
            headerClassName: "ms-hiddenXlDown",
            isIconOnly: true,
            key: "nbreTicketsFerme",
            onRender: item => {
                const nbreTicketsFerme = item.nbreTicketsFerme;
                return !!nbreTicketsFerme && <span title="Tickets fermés" className="badge badge-success" >{nbreTicketsFerme}</span>;
            }
        }, {
            ariaLabel: "Traité supervision",
            className: "ms-hiddenLgDown",
            headerClassName: "ms-hiddenLgDown",
            isIconOnly: true,
            key: "traiteSupervision",
            onRender: item => item.traiteSupervision && <Icon
                ariaLabel="Traité supervision"
                iconName="CheckMark"
                styles={{ root: { fontSize: "18px" } }}
                title="Traité supervision"
            />
        }, {
            ariaLabel: "Modifier le projet",
            isIconOnly: true,
            key: "edition",
            onRender: item => <IconButton
                ariaLabel="Edition"
                iconProps={{ iconName: "Edit" }}
                onClick={this._togglePanel("Tache", true, item)}
                title="Modifier le projet"
            />
        }];

        return columns;

    };

    _getFiltres = () => {
        return { ...PanelFiltres.defaultState };
    };

    _getItems = () => {
        return [{
            iconProps: { iconName: "Add" },
            key: "new",
            name: "Nouveau projet",
            onClick: this._togglePanel("Tache", true)
        }];
    };

    _onColumnHeaderClick = (sortedColumn, isSortedDescending) => {
        this._sortedColumn = sortedColumn;
        this._isSortedDescending = isSortedDescending;
        this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    _onSearch = (keyword) => {
        this._filtres.recherche = keyword;
        this.setState({ pageIndex: 1 }, this._chargementDonnees);
    };

    _onSelectionChanged = (items) => {
        const { onSelectionTache } = this.props;
        if (items.length > 0) {
            const item = items[0];
            if (!!onSelectionTache && typeof onSelectionTache === "function")
                onSelectionTache(item.idTache)
        }
    };

    _onScroll = () => {
        this.setState(
            prevState => ({ pageIndex: prevState.pageIndex + 1 }),
            this._chargementDonnees
        );
    };

    _togglePanel = (nomPanel, isOpen, item, callback) => () => {
        this.setState(
            {
                [`afficherPanel${nomPanel}`]: isOpen,
                itemActif: item || {},
            },
            !!callback && typeof callback === "function" ? callback() : null
        );
    };

    // KP - 02/01/2023 : inutile, le périmètre n'influence pas le résultat
    //componentDidUpdate = () => {
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");
    //        this.setState(
    //            { pageIndex: 1 },
    //            this._chargementDonnees
    //        );
    //    }
    //};

    render = () => {

        const { masquerOngletTickets } = this.props;
        const { afficherPanelFiltres, afficherPanelTache, itemActif, items } = this.state;

        return <Fragment>

            <EUIDetailsList
                columns={this._columns}
                getKey={item => item.idTache}
                isSortedDescending={this._isSortedDescending}
                items={items}
                menuItems={this._getItems()}
                onColumnHeaderClick={this._onColumnHeaderClick}
                onFilterButtonClick={this._togglePanel("Filtres", true)}
                onSearch={this._onSearch}
                onSelectionChanged={this._onSelectionChanged}
                onScroll={this._onScroll}
                selectionMode={SelectionMode.single}
                sortedColumn={this._sortedColumn}
            />

            <FicheTache
                idTache={itemActif.idTache}
                isOpen={afficherPanelTache}
                masquerOngletTickets={masquerOngletTickets}
                onDismiss={this._togglePanel("Tache", false, {}, this._chargementDonnees)}
                onSave={this._togglePanel("Tache", false, {}, this._chargementDonnees)}
            />

            <PanelFiltres
                filtres={this._filtres}
                isOpen={afficherPanelFiltres}
                onValidate={this._appliquerFiltres}
                onDismiss={this._togglePanel("Filtres", false)}
            />

        </Fragment>;
    }
}

class PanelFiltres extends Component {

    static defaultProps = {
        filtres: {},
    };

    static defaultState = {
        listIdEtat: [],
        idTypeDemande: 0,
        recherche: "",
    };

    constructor(props) {
        super(props);
        this.state = this._getFiltresParDefaut();
    };

    _appliquerFiltres = () => {
        const filtres = { ...this.state };
        this.props.onValidate(filtres);
    };

    _getFiltresParDefaut = () => {
        const filtres = { ...PanelFiltres.defaultState };
        return filtres;
    };

    _reinitialiserFiltres = () => {
        this.setState(this._getFiltresParDefaut());
    };

    _onOpen = () => {
        this.setState({ ...this.props.filtres });
    };

    componentDidMount = () => {
        this._appliquerFiltres();
    };

    render = () => {

        const { isOpen, onDismiss } = this.props;
        const { listIdEtat, idTypeDemande } = this.state;

        return <EUIPanel
            headerText="Filtres"
            isOpen={isOpen}
            onDismiss={onDismiss}
            onOpen={this._onOpen}
            onResetFilters={this._reinitialiserFiltres}
            onValidate={this._appliquerFiltres}
        >

            <ComboBoxEtat
                multiSelect
                onChange={(event, option, _, value, item) => {
                    const index = listIdEtat.indexOf(option.key);

                    let newListIdEtat = [...listIdEtat];
                    if (option.selected && index === -1)
                        newListIdEtat.push(option.key);
                    else newListIdEtat.splice(index, 1);

                    this.setState({ listIdEtat: newListIdEtat })
                }}
                selectedKey={listIdEtat}
            />

            <ComboBoxTypeDeDemande
                onChange={(event, option) => this.setState({ idTypeDemande: option.key })}
                selectedKey={idTypeDemande}
                styles={{ root: { marginTop: "8px" } }}
            />

        </EUIPanel>;

    };

};